import Navbar from "../components/Navbar.tsx";
import type { ReactElement } from "react";
import { Toaster } from "react-hot-toast";

const AppLayout = ({ children }: { children: ReactElement }) => {
  return (
    <>
      <div className={"flex flex-row"}>
        <Navbar />
        <div className="flex w-full h-screen flex-col bg-base-200">
          {children}
        </div>
        <Toaster position="bottom-right" />
      </div>
    </>
  );
};

export default AppLayout;
